
import atlasApi									from "../utils/atlasapi";
import {
	Button,
	Col,
	Row,
	Dropdown,
	Form
}												from "react-bootstrap";
import {
	PencilSimple,
	Info,
	Eye,
	Trash,
	DotsThreeVertical,
	X,
	MapPinSimple
}												from "@phosphor-icons/react";
import DataTable								from 'react-data-table-component';
import EditNow									from "../components/EditNow";
import ReactDOM									from "react-dom/client";
import GateIcon									from "../assets/svg/GateIcon";
import Tool										from "../classes/Tool";
import LayerGates								from "../classes/LayerGates";

class ToolGate extends Tool {

	highlightedOnList	= [];
	hiddenGates			= [];
	allHidden			= false;
	modified			= false;

	type				= 'gates';
	itemsName			= 'gates';
	id					= 'id';
	infolayerId			= 'gates';

	constructor(p) {
		super();
		this.tc		= p;
		this.canvas	= this.tc.map.getCanvasContainer();
		if (ToolGate.tabIndex === undefined)
			ToolGate.tabIndex = null;
	}

	save(promise) {
		const { setters } = this.tc.draw.context;
		setters.setSaveState('saving');
		return promise
			.then((res) => { this.tc.checkOutdated(res); setters.setSaveState('finished'); return res; })
			.catch(err => { setters.setSaveState('error'); throw err; });
	}

	getToolLayer() {
		return LayerGates;
	}

	setCursor(cur) {
		this.tc.map.getContainer().classList.add(cur);
		return this;
	}

	remCursor(cur) {
		this.tc.map.getContainer().classList.remove(cur);
		return this;
	}

	init() {
		this.display();
		this.setEventHandlers();
	}

	exit() {
		if (this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(ToolGate.tabIndex);
		ToolGate.tabIndex = null;
		this.removeEventHandlers();
	}

	setEventHandlers() {
		if (!this.tc) 
			return;
		
		this.setCursor("cursor-add-gate");
		this.tc.map.on('click', this.addGate);
		this.tc.map.on('contextmenu', this.handleRightClick);
		this.tc.map.on('mousedown', LayerGates.layerId, this.onDown);
		this.tc.map.on('touchstart', LayerGates.layerId, this.onTouchStart);
		this.setInOutListeners();
	}

	setInOutListeners() {
		this.tc.map.on('mouseenter', LayerGates.layerId, this.onEnter);
		this.tc.map.on('mouseleave', LayerGates.layerId, this.onLeave);
	}

	unsetInOutListeners() {
		this.tc.map.off('mouseenter', LayerGates.layerId, this.onEnter);
		this.tc.map.off('mouseleave', LayerGates.layerId, this.onLeave);
	}

	removeEventHandlers() {
		if (!this.tc) return;
		this.tc.map.off('click', this.addGate);
		this.tc.map.off('contextmenu', this.handleRightClick);
		this.tc.map.off('mousedown', LayerGates.layerId, this.onDown);
		this.tc.map.off('touchstart', LayerGates.layerId, this.onTouchStart);
		this.unsetInOutListeners();
		this.remCursor("cursor-add-gate");
		this.remCursor("cursor-grabbing");
	}

	onDown = (e) => {
		if (e.originalEvent.which != 1) return;
		e.preventDefault();
		this.unsetInOutListeners();
		this.getClickedGate(e);
		this.setCursor('cursor-grabbing');
		this.tc.map.mouseDown = true;
		this.tc.map.on('mousemove', this.onMove);
		this.tc.map.once('mouseup', this.onUp);
	}

	onMove = (e) => {
		const coords = e.lngLat;
		this.hasMoved = true;
		this.canvas.style.cursor = 'grabbing';
		LayerGates.data.features[this.currentGateIdx].geometry.coordinates = [coords.lng, coords.lat];
		this.setData(LayerGates.data);
	}

	onUp = (e) => {
		if (e.originalEvent.which != 1) return;
		const coords = e.lngLat;
		this.setInOutListeners();
		this.remCursor('cursor-grabbing');
		if (this.hasMoved && this.currentGateId) {
			this.updateGate(this.currentGateId, [coords.lng, coords.lat]);
			this.hasMoved = false;
		}
		this.currentGateId	= false;
		this.currentGateIdx	= false;
		delete this.tc.map.mouseDown;
		this.tc.map.off('mousemove', this.onMove);
		this.tc.map.off('touchmove', this.onMove);
	}

	onTouchStart = (e) => {
		if (e.points.length !== 1) return;
		e.preventDefault();
		this.getClickedGate(e);
		this.tc.map.mouseDown = true;
		this.tc.map.on('touchmove', this.onMove);
		this.tc.map.once('touchend', this.onUp);
	}

	getClickedGate(e) {
		var features = this.tc.map.queryRenderedFeatures(e.point, { layers: [LayerGates.layerId] });
		if (features[0]) {
			this.currentGateId	= features[0].id ?? features[0].properties.tempid;
			this.currentGateIdx	= features[0].properties.idx;
		}
	}

	onEnter = (e) => {
		this.remCursor("cursor-add-gate").setCursor("cursor-pointer");
		const id = e.features[0].id ?? e.features[0].properties.tempid;
		this.lastHoverId = id;
		this.highlightOnMap(id);
		this.highlightOnList(id);
	}

	onLeave = (e) => {
		this.remCursor("cursor-pointer").setCursor("cursor-add-gate");
		this.deHighlightOnMap(this.lastHoverId);
		this.deHighlightOnList(this.lastHoverId);
	}

	addGate = (e) => {
		
		this.closeContextMenu();

		if (this.tc.secondaryHandler) return;

		var features = this.tc.map.queryRenderedFeatures(e.point, { layers: [LayerGates.layerId] });
		if (features.length) {
			this.handleGateClick(features[0].id ?? features[0].properties.tempid);
			return;
		}

		e.originalEvent.stopPropagation();

		var newGate = {
			"geometry": {
				"coordinates": [e.lngLat.lng, e.lngLat.lat],
				"type": "Point"
			},
			"id":	'temp_' + Math.random().toString(36).substr(2, 9),
			"name":	"Gate " + (this.tc.scenario.gates.length + 1),
			"type":	"Feature"
		}

		this.tc.scenario.gates.push(newGate);
		this.resetLayer();
		this.tc.setScenario(this.tc.scenario);

		this.tc.map.fire("addGate", { scenario: this.tc.scenario, gate: newGate });

		if (this.tc.scenario.scenario_id) {
			this.save(
				atlasApi.createGate(
					this.tc.scenario.projectid,
					this.tc.scenario.scenario_id,
					e.lngLat.lat,
					e.lngLat.lng,
					newGate.name
				).then((res) => {
					if (res?.id) {
						const tempId = newGate.id;
						const idx = this.tc.scenario.gates.findIndex(g => g.id === tempId);
						if (idx > -1) {
							this.tc.scenario.gates[idx].id = res.id;
							this.tc.setScenario(this.tc.scenario);
							this.resetLayer();
						}
					}
					return res;
				})
			);
		}
	}

	removeGate = (e, gId) => {
		e?.originalEvent?.stopPropagation();
		var gateId;

		if (gId) {
			gateId = gId;
		} else {
			var features = this.tc.map.queryRenderedFeatures(e.point, { layers: [LayerGates.layerId] });
			if (features.length)
				gateId = features[0].id ?? features[0].properties.tempid;
		}

		if (!gateId) return;

		this.removeItem(gateId);
		this.resetLayer();

		this.tc.map.fire("removeGate", { scenario: this.tc.scenario, gate: gateId });
		this.display();
	}

	updateGate = (id, coordinates) => {
		if (!this.tc.scenario) return;

		var i = this.tc.scenario.gates.findIndex((elem) => elem.id == id);
		if (i > -1) {
			if (coordinates) {
				this.tc.scenario.gates[i].geometry.coordinates = coordinates;

				if (!isNaN(id) && this.tc.scenario.scenario_id)
					this.save(atlasApi.updateGate(this.tc.scenario.projectid, this.tc.scenario.scenario_id, id, coordinates[1], coordinates[0]));
			} else {
				if (!isNaN(id) && this.tc.scenario.scenario_id)
					this.save(atlasApi.deleteGate(this.tc.scenario.projectid, this.tc.scenario.scenario_id, id));

				delete this.tc.scenario.gates[i].geometry;

				if (typeof this.tc.scenario.gates[i].id !== 'number')
					this.tc.scenario.gates.splice(i, 1);
			}

			this.tc.setScenario(this.tc.scenario);
		}
	}

	updateGateName(name, id, refresh) {
		if (!this.tc.scenario) return;

		var i = this.tc.scenario.gates.findIndex((elem) => elem.id == id);
		if (i > -1) {
			this.tc.scenario.gates[i].name = name ? name : 'Gate ' + id;

			if (!isNaN(id) && this.tc.scenario.scenario_id)
				this.save(atlasApi.updateGateName(this.tc.scenario.projectid, this.tc.scenario.scenario_id, id, this.tc.scenario.gates[i].name));

			this.tc.scenario.modified = 1;
		}

		if (refresh)
			this.resetLayer();
	}


	unselectAll() {
		if (this.currentGate?.id)
			this.updateMapFeatPop('id', this.currentGate.id, { selected: false });
	}

	select(id) {
		this.updateMapFeatPop('id', id, { selected: true });
	}

	handleGateClick = (id) => {
		this.unselectAll();
		this.currentGate = this.tc.scenario.gates.find((g) => g.id == id);
		this.select(id);
		this.display();
	}

	tName(row, index) {
		return row.name !== '' ? row.name : 'Gate ' + (index + 1);
	}

	highlightOnMap = (id) => {
		this.lastHoverId = id;
		this.updateMapFeatPop('id', id, { hover: true });
	}

	deHighlightOnMap = (id) => {
		this.updateMapFeatPop('id', id ?? this.lastHoverId, { hover: false });
	}

	highlightOnList = (id) => {
		this.highlightedOnList.push(this.idString(id));
		this.highlightedOnList = [...new Set(this.highlightedOnList)];
		this.display();
	}

	deHighlightOnList = (id) => {
		const index = this.highlightedOnList.indexOf(this.idString(id));
		if (index > -1) this.highlightedOnList.splice(index, 1);
		this.display();
	}

	handleRowClick = (row) => {
		this.unselectAll();
		this.currentGate = this.tc.scenario.gates.find((g) => g.id == row.id);
		this.select(row.id);
		this.display();
	}

	closeContextMenu() {
		if (!this.tc) return;
		var a;
		if (a = this.tc.map.getContainer().querySelector(".toolContextMenu"))
			a.remove();
	}

	handleRightClick = (e) => {
		e.originalEvent.preventDefault();

		var features = this.tc.map.queryRenderedFeatures(e.point, { layers: [LayerGates.layerId] });
		if (!features.length) return;

		var id = features[0].id ?? features[0].properties.tempid;

		var wrp = document.createElement("div");
		wrp.className = "toolContextMenu";
		wrp.style.left = e.point.x + 'px';
		wrp.style.top = e.point.y + 'px';

		this.closeContextMenu();
		this.tc.map.getContainer().appendChild(wrp);
		ReactDOM.createRoot(wrp).render(this.contextMenu(e, id));
	}

	handleHideAllGates = () => {
		if (!this.allHidden) {
			this.hiddenGates = this.tc.scenario.gates.map((g) => {
				this.handleToggleGate(g.id, true, true);
				return g.id;
			});
			this.allHidden = true;
		} else {
			const copy = this.hiddenGates.slice(0);
			copy.forEach((id) => { this.handleToggleGate(id, false, true); });
			this.hiddenGates = [];
			this.allHidden = false;
		}
		this.display();
	}

	handleToggleGate = (id, force, dontRefresh) => {
		const isHidden = typeof force === 'boolean' ? force : !this.hiddenGates.includes(id);

		if (isHidden) {
			if (!this.hiddenGates.includes(id)) this.hiddenGates.push(id);
		} else {
			const idx = this.hiddenGates.indexOf(id);
			if (idx > -1) this.hiddenGates.splice(idx, 1);
		}

		this.allHidden = this.hiddenGates.length === this.tc.scenario.gates.length;
		this.updateMapFeatPop('id', id, { invisible: isHidden });

		if (!dontRefresh) this.display();
	}

	handleRemoveGate = (e, id) => {
		this.removeGate(e, id);
		this.display();
		return true;
	}

	handleSelect = (e, row) => {
		if (!this.selected) this.selected = [];
		const idx = this.selected.findIndex((a) => a.id == row.id);
		if (idx !== -1) this.selected.splice(idx, 1);
		else this.selected.push(row);
		this.display();
	}

	handleSelectAll = () => {
		if (!this.selected) this.selected = [];
		const items = (this.tc.scenario.gates ?? []).filter(g => !!g.geometry);
		const allSelected = items.length > 0 && items.every(d => this.selected.some(s => s.id === d.id));
		if (allSelected) { this.selected = []; } else { this.selected = items.slice(); }
		this.display();
	}

	removeItem = (id) => {
		const i = this.tc.scenario.gates.findIndex(g => g.id == id);
		if (i > -1) {
			this.tc.scenario.gates.splice(i, 1);
			this.tc.setScenario(this.tc.scenario);
		}
	}

	handleBulkDelete = () => {
		if (!this.selected?.length) return;

		const persistedIds = this.selected.map(r => r.id).filter(id => !isNaN(id));

		this.selected.forEach(row => { this.removeItem(row.id); });
		this.selected = [];

		if (persistedIds.length && this.tc.scenario.scenario_id)
			this.save(atlasApi.bulkDeleteGates(this.tc.scenario.projectid, this.tc.scenario.scenario_id, persistedIds));
		this.resetLayer();
		this.display();
	}

	handleUpdateName(newName, id) {
		this.updateGateName(newName, id, true);
		this.display();
	}

	handleEditGate(e, id) {
		document.getElementById('edit-static-gate-' + id)
			.dispatchEvent(new MouseEvent("dblclick", { 'view': window, 'bubbles': true, 'cancelable': true }));
	}

	handleExitDetail = () => {
		this.currentGate = null;
		this.unselectAll();
		this.display();
	}

	isSelectedOnList = (row) => {
		return this.highlightedOnList.includes(this.idString(row.id));
	}

	contextMenu = (map_event, id) => {
		return (
			<>
				<button className="btn" onClick={() => { this.handleEditGate(map_event, id); this.closeContextMenu(); }}><PencilSimple size={20} /> Edit name</button>
				<button className="btn" onClick={() => { this.removeGate(map_event, id); this.closeContextMenu(); }}><Trash size={20} /> Remove Gate</button>
			</>
		);
	}

	display() {
		if (this.tc.serviceBar.current)
			ToolGate.tabIndex = this.tc.serviceBar.current.inject(
				this.currentGate ? this.renderDetail() : this.render(),
				ToolGate.tabIndex
			);
	}

	renderDetail() {
		if (!this.currentGate) return;
		const coords = this.currentGate.geometry?.coordinates;

		return (
			<div className="project-gates">
				<div className="title">
					{this.currentGate.name}
					<span onClick={() => { this.handleExitDetail(); }} className="btn btn-close alt float-end"><X size={16} /></span>
				</div>
				<div className="scroll">
					<div className="separator">
						<span>About this gate</span>
					</div>
					<div className="gate-detail">
						<Row className="basic-info mb-2">
							<Col xs="12">
								<MapPinSimple size={16} />
								<span>Name: </span>
								<EditNow
									id={'gate-' + this.currentGate.id}
									value={this.currentGate.name}
									editable={true}
									onUpdate={(val) => { this.handleUpdateName(val, this.currentGate.id); }}
								/>
							</Col>
						</Row>
						{coords &&
							<Row className="basic-info mb-2">
								<Col xs="12">
									<GateIcon size={16} />
									<span>Location: </span>
									{coords[1].toFixed(5)}, {coords[0].toFixed(5)}
								</Col>
							</Row>
						}
					</div>
				</div>
			</div>
		);
	}

	render() {
		var gates = this.tc.scenario.gates
			? this.tc.scenario.gates.filter((g) => !!g.geometry)
			: (this.tc.scenario.gates = []);

		return (
			<div className="project-gates">
				<div className="title">
					Gates
				</div>
				<div className="scroll">
					<div className="content p-0">
						<DataTable
							data={gates}
							columns={[
								{
									name: <Eye onClick={this.handleHideAllGates} className={this.areAllHidden() ? 'opacity-25' : ''} size={16} />,
									id: 'id-eye',
									selector: row => row.id,
									format: (row) => (
										<Eye
											onClick={() => { this.handleToggleGate(row.id, undefined, false); }}
											id={"gate_" + row.id}
											data-id={row.id}
											className={this.hiddenGates.includes(row.id) || this.allHidden ? 'opacity-25' : ''}
											size={16}
										/>
									),
									width: "28px",
									style: { padding: '0' }
								},
								{
									name: (
										<Form.Check
											type="checkbox"
											checked={
												!!(this.tc.scenario.gates?.filter(g => !!g.geometry).length) &&
												this.tc.scenario.gates.filter(g => !!g.geometry).every(d => this.selected && this.selected.some(s => s.id === d.id))
											}
											ref={el => {
												if (el) el.indeterminate =
													!!(this.selected?.length) &&
													this.selected.length < (this.tc.scenario.gates?.filter(g => !!g.geometry).length ?? 0);
											}}
											onChange={this.handleSelectAll}
										/>
									),
									selector: this.tName,
									format: (row) => (
										<label className="checkbox-pad">
											<Form.Check
												type="checkbox"
												id={"check-" + row.id}
												checked={this.selected && this.selected.some((a) => a.id == row.id)}
												onClick={(e) => { this.handleSelect(e, row); }}
											/>
										</label>
									),
									width: "25px",
									style: { padding: '0px !important' }
								},
								{
									name: 'NAME',
									selector: this.tName,
									format: (row, index) => (
										<EditNow
											id={'gate-' + row.id}
											value={this.tName(row, index)}
											onClick={() => { this.handleRowClick(row); }}
											editable={true}
											onUpdate={(val) => { this.handleUpdateName(val, row.id); }}
										/>
									),
									sortable: true,
									width: "100%"
								},
								{
									name: '',
									cell: row => (
										<div className="context-menu" data-tag="allowRowEvents">
											<Dropdown className="minimal">
												<Dropdown.Toggle className="p-0 px-1" variant="default">
													<DotsThreeVertical size={16} />
												</Dropdown.Toggle>
												<Dropdown.Menu>
													<Dropdown.Item href="#" onClick={(e) => { this.handleEditGate(e, row.id); }}>
														<PencilSimple size={16} /> Edit name
													</Dropdown.Item>
													<Dropdown.Item href="#" onClick={(e) => { this.handleRemoveGate(e, row.id); }} className="text-danger">
														<Trash size={16} /> Remove gate
													</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown>
										</div>
									),
									width: "20px"
								}
							]}
							customStyles={{
								headCells: {
									style: {
										padding: '.5rem .3rem',
										minWidth: '0px !important',
										boxSizing: 'content-box',
										fontWeight: 'bold'
									}
								},
								cells: {
									style: {
										padding: '.5rem .3rem',
										minWidth: '0px !important',
										boxSizing: 'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color: 'var(--bs-body-color)',
										'&:last-child': { paddingRight: '1rem' }
									}
								},
								rows: {
									style: { minHeight: "0" },
									selectedHighlightStyle: { backgroundColor: 'red' }
								}
							}}
							onRowMouseEnter={row => this.highlightOnMap(row.id)}
							onRowMouseLeave={row => this.deHighlightOnMap(row.id)}
							onRowClicked={this.handleRowClick}
							selectableRowSelected={r => this.isSelectedOnList(r)}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							sortIcon={<i className="ri-expand-up-down-line" />}
							noDataComponent={
								<Row className="p-0 py-3 m-0">
									<Col xs="1 pe-0">
										<Info className="text-danger" size={15} />
									</Col>
									<Col xs="11 ps-0">
										<b>Please note:</b> There are currently no gates placed in this scenario.
									</Col>
								</Row>
							}
						/>

						{this.selected && !!this.selected.length &&
							<Row className="p-3 batch-action">
								<Col xs="6">
									{this.selected.length} Items selected
								</Col>
								<Col xs="6 text-end">
									<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
								</Col>
							</Row>
						}
						{(!this.selected || !this.selected.length) && !!this.tc.scenario?.gates?.length &&
							<Row className="p-3 batch-action">
								<Col xs="2">
									Total 
								</Col>
								<Col xs="10">
									{this.tc.scenario.gates.length } Gates 
								</Col>
							</Row>
						}
					</div>
				</div>
			</div>
		);
	}
}

export default ToolGate;
